export function convertDateToISTFormat(isoTimestamp: string) {
	// Define timezones for UTC and IST
	const utcTimezone = 'UTC';
	const istTimezone = 'Asia/Kolkata';

	// Convert ISO timestamp to Date object in UTC timezone
	const utcDatetime = new Date(isoTimestamp);

	// Convert UTC Date to IST Date
	const istDatetime = new Date(utcDatetime.toLocaleString('en-US', { timeZone: istTimezone }));

	// Format the IST Date as required
	const formattedDate = istDatetime.toLocaleString('en-US', { day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' });

	return formattedDate;
}

export function hasISTTimestampPassed(isoTimestamp: string) {
	const currentDatetime = new Date();
	const timestampDatetime = new Date(isoTimestamp);

	// Convert both current and timestamp Date objects to IST
	const istTimezone = 'Asia/Kolkata';
	currentDatetime.toLocaleString('en-IN', { timeZone: istTimezone });
	timestampDatetime.toLocaleString('en-IN', { timeZone: istTimezone });

	return timestampDatetime <= currentDatetime;
}

export const getTimeRemaining = (date: any) => {
	const total = Date.parse(date) - Date.now();

	const days = String(Math.floor(total / (1000 * 60 * 60 * 24))).padStart(2, '0');
	const hours = String(Math.floor((total / (1000 * 60 * 60)) % 24)).padStart(2, '0');
	const minutes = String(Math.floor((total / 1000 / 60) % 60)).padStart(2, '0');
	const seconds = String(Math.floor((total / 1000) % 60)).padStart(2, '0');

	if (+total < 0) {
		return { total: 0, days: '00', hours: '00', minutes: '00', seconds: '00' };
	}

	return {
		total,
		days,
		hours,
		minutes,
		seconds,
	};
};
